import { useState } from "react";

const TempoFinder = () => {

  const [bpm, setBpm] = useState(0);

  var hits = 0;
  var startTime = new Date();
  var currentTime = new Date();
  var difference = 0;
  var active = false;

  document.addEventListener("keydown", function(event){
    if (event.key == " "){
      if (active){
        hits++;
        currentTime = new Date();
        difference = (currentTime.getTime() - startTime.getTime()) / 60000;
        setBpm(Math.round(hits / difference));
      } else{
        active = true;
        hits = 0;
        startTime = new Date();
        currentTime = new Date();
      }
    } else if (event.key == "Enter"){
      active = false;
      setBpm(0);
    }
  });

  return (

    <section className="articles">
      
      <article className="web-toy">
        <div className="centered">
          <h3>Tempo finder</h3>
          <p>Press enter to reset, press space to tap the tempo</p>
          <h1>{ bpm } BPM</h1>
        </div>
      </article>

    </section>

  );
}

export default TempoFinder;